/* tslint:disable:forin */
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export const forEachElementInForm = (group: FormGroup | FormArray, func: (FormControl) => any = () => {}) => {
  func(group);

  for (const i in group.controls) {
    const control = group.controls[i];

    if (control instanceof FormControl) {
      func(control);
    } else {
      forEachElementInForm(control, func);
    }
  }
};

export const markFormAsTouched = (group: FormGroup | FormArray) => {
  forEachElementInForm(group, control => control.markAsTouched());
};
